import React from "react";
import { BiSolidPhoneCall } from "react-icons/bi";
import { MdEmail } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa6";
import { BiLogoTwitter } from "react-icons/bi";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import FollowUs from "../Footer/FollowUs";
import LetsGet from "../Footer/LetsGet";
import { motion } from "framer-motion";

const Collaborate = () => {

  const text = "LET’S COLLABORATE";

  const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 2.3,
      ease: "easeOut",
    },
  },
};

  return (
    <div className="overflow-x-hidden">
      <Header />
    <div className="w-full py-28 flex justify-center">
     
      <div className="max-w-6xl w-full px-4 ">

        <div className="text-center mb-14">
          <p className="montserrat text-[#F56E0F] text-[20px] tracking-widest">
            Contact Us
          </p>
          {/* <h2 className="heading text-5xl text-[#252525] mt-2">
            LET’S COLLABORATE
          </h2> */}
          <h2 className="heading text-5xl text-[#252525] mt-2">
            {text.split("").map((char, index) => (
              <motion.span
                key={index}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{
                  delay: index * 0.08,
                  duration: 0.05,
                }}
              >
                {char}
              </motion.span>
            ))}
          </h2>
          <p className="montserrat text-[#252525] mt-3 max-w-3xl mx-auto">
            Have questions? We’re here for you. Drop us a line, write us an email, or send us a text.
          </p>
        </div>

        
        {/* <div className="bg-orange-500 rounded-[32px] p-6 md:p-10 grid grid-cols-1 md:grid-cols-[40%_60%] gap-5 relative overflow-hidden"> */}
        <motion.div
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    className="bg-orange-500 rounded-[32px] p-6 md:p-10 grid grid-cols-1 md:grid-cols-[40%_60%] gap-5 relative overflow-hidden"
                  >

          <form className="text-white space-y-8 order-1 md:order-2">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

              <div>
                <label className="heading text-lg uppercase">Name</label>
                <input
                  className="w-full bg-transparent border-b border-white/60 py-2 focus:outline-none"
                />
              </div>

              <div>
                <label className="heading text-lg uppercase">Email</label>
                <input
                  className="w-full bg-transparent border-b border-white/60 py-2 focus:outline-none"
                />
              </div>

              <div>
                <label className="heading text-lg uppercase">Phone Number</label>
                <input
                  placeholder="+1 012 3456 789"
                  className="w-full bg-transparent border-b border-white/60 py-2 placeholder-white/70 focus:outline-none"
                />
              </div>

              <div>
                <label className="heading text-lg uppercase">Product Question</label>
                <select className="w-full bg-transparent border-b border-white/60 py-2 focus:outline-none">
                  <option className="text-black"></option>
                  <option className="text-black">Design</option>
                  <option className="text-black">Development</option>
                  <option className="text-black">Marketing</option>
                </select>
              </div>
            </div>

            <div>
              <label className="heading text-lg uppercase">Message</label>
              <textarea
                rows="2"
                placeholder="Write your message..."
                className="montserrat w-full bg-transparent border-b border-white/60 py-2 placeholder-white/70 focus:outline-none"
              />
            </div>

            <div className="flex items-center gap-3 text-sm text-[#FFFFFF]">
              <input type="checkbox"/>
              <span>
                subscribe to receive the latest news and exclusive offers
              </span>
            </div>

            <div className="flex flex-col gap-6">
              <div className="bg-white text-black rounded-md p-3 flex items-center gap-3 w-fit">
                <input type="checkbox" className="w-4 h-4" />
                <span className="text-sm">I'm not a robot</span>
                <span className="text-xs text-gray-400 ml-4">reCAPTCHA</span>
              </div>

            </div>
            <div className="flex flex-col items-start">
              
              <button className="montserrat bg-black text-white px-10 py-3 rounded-full hover:bg-gray-900 transition self-start">
                Send Message
              </button>
            <div className="hidden lg:flex items-center justify-center w-40 h-20 overflow-visible self-center mr-20">
                <img
                    src="assets/collaborate1.png"
                    alt="img"
                    className="h-full scale-150 object-contain"
                />
                </div>
                </div>
          </form>

          <div className="text-[#FFFFFF] heading order-2 md:order-1">
            <h3 className="text-[30px] mb-2">
              CONTACT INFORMATION
            </h3>
            <p className="montserrat text-sm mb-10 md:mb-28">
              Say something to start a live chat!
            </p>

            <div className="text-white space-y-8">
              <a
                href="tel:+19498806134"
                className="montserrat flex items-center gap-4 cursor-pointer"
              >
                <span className="text-xl">
                  <BiSolidPhoneCall />
                </span>
                <span>(949) 880-6134</span>
              </a>

              {/* <div className="montserrat flex items-center gap-4">
                <span className="text-xl">
                  <MdEmail />
                </span>
                <span>contact@open-studios.co</span>
              </div> */}
              <a
                href="mailto:contact@open-studios.co"
                className="montserrat flex items-center gap-4 cursor-pointer"
              >
                <span className="text-xl">
                  <MdEmail />
                </span>
                <span>contact@open-studios.co</span>
              </a>

              <div className="montserrat flex items-start gap-4">
                <span className="text-xl">
                  <FaLocationDot />
                </span>
                <a
                href="https://www.google.com/maps/search/?api=1&query=404+Pride+Empire+Race+Course+Sadar+Rajkot+360001"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline"
              >
                <span>
                  404, Pride Empire, Race Course, Sadar <br />
                  Road, Rajkot, Gujarat, 360005
                </span>
                </a>
              </div>
            </div>

            <div className="flex gap-4 mt-10 md:mt-48">
              <div className="w-8 h-8 rounded-full bg-white text-black flex items-center justify-center text-lg">
                <FaInstagram />
              </div>
              <div className="w-8 h-8 rounded-full bg-white text-black flex items-center justify-center text-lg">
                <FaYoutube />
              </div>
              <div className="w-8 h-8 rounded-full bg-white text-black flex items-center justify-center text-lg">
                <BiLogoTwitter />
              </div>
            </div>

           <div
            className="hidden lg:block absolute
            bottom-2 left-48
            xl:left-60
            2xl:right-72
            w-44 h-44 bg-[#FAC79F] rounded-tl-[120px]"
            />
            <div
            className="hidden lg:block absolute 
            bottom-14 left-40
            xl:left-52
            2xl:right-[22rem]
            w-32 h-32 bg-orange-400/50 rounded-full"
            />

            </div>
          </motion.div>        
        {/* </div> */}
      </div>
    </div>
    
    <LetsGet />
    <FollowUs />
    <Footer />
    </div>
  );
};

export default Collaborate;
